var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLineHeightSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 23,
    viewBox: "0 0 48 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_489",
    "data-name": "Group 489",
    transform: "translate(-9607.686 -2444.25)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_499",
    "data-name": "Rectangle 499",
    width: 48,
    height: 3,
    rx: 1.5,
    transform: "translate(9607.686 2444.25)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_502",
    "data-name": "Rectangle 502",
    width: 48,
    height: 3,
    rx: 1.5,
    transform: "translate(9607.686 2454.25)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_505",
    "data-name": "Rectangle 505",
    width: 48,
    height: 3,
    rx: 1.5,
    transform: "translate(9607.686 2464.25)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineHeightSm);
export default __webpack_public_path__ + "static/media/line-height-sm.15ef053a42ccc8bcddded65a76757cc5.svg";
export { ForwardRef as ReactComponent };